export default {"src":"/_next/static/media/icon-receive.b71a577a.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};